import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 235px 0 235px;
  padding: 18px 0;
  justify-content: space-between;
  ${"" /* background-color: #FAFAFA; */}
  aliten-items: center;
  @media (max-width: 1350px) {
    margin: 0 130px 0 130px;
  }

  @media (max-width: 1024px) {
    margin: 0 26px 0 38px;
  }
`;

export const Logo = styled.img`
  width: 48.55px;
  height: 48.55px;
  margin-right: 60px;
  @media (max-width: 600px) {
    margin-right: 30px;
  }
`;

export const TextHeading = styled.h1`
  margin: 0;
  font-family: NunitoSans-Bold;
  font-style: normal;
  font-weight: 700;
  ${'' /* text-align: center; */}
  font-size: 30px;
  line-height: 65.47px;
  letter-spacing: 1.5px;

  /* grey */

  color: #000000;
  @media (max-width: 600px) {
    font-size: 24px;
    line-height: 33px;
  }
`;

export const Line = styled.div`
  width:  100px;
  height: 3px;
  background-size: cover;
  background-image: url("/images/icons/Rectangle 36.png");
`;

export const SubHeading = styled.p`
  margin: 0;
  font-family: NunitoSans-Regular;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 35px;
  /* identical to box height, or 150% */

  letter-spacing: 0.5px;

  /* grey 900 */

  color: #d67723;
`;

export const Heading = styled.h1`
  font-family: NunitoSans-Regular;
  font-style: normal;
  font-weight: bold;
  font-size: 17px;
  line-height: 27px;
  letter-spacing: 1px;
  margin: 0;
  margin-bottom: 7px;
  /* black */

  color: #000000;
`;

export const Pane = styled.div`
  display: flex;
  width: 413px;
  height: 204px;
  align-items: center;
  padding: 10px;
  border-radius: 12px;
  @media (max-width: 1000px) {
    width: 100%;
    padding: 0 45px;
    text-align: center;
  }
  &:hover {
    background-color: #fafafa;
  }
  @media (max-width: 600px) {
    padding: 0px;
    text-align: left;
  }
`;

export const Content = styled.h1`
  display: flex;
  flex-direction: column;
`;

export const Text = styled.p`
  margin: 0;
  font-family: NunitoSans-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 1px;

  /* grey */

  color: #606060;
`;

export const Frame = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
`;
